import React from 'react';

const isInteractiveElement = element => {
  if (!React.isValidElement(element)) return false;
  const { type } = element;
  if (typeof type === 'string') {
    return ['a', 'button', 'input', 'select', 'textarea'].includes(type);
  }
  return false;
};

export default isInteractiveElement;
